import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import devLogger from 'react-utils/devLogger';
import { getObjectTypeName } from 'automation-ui-references/object-types/objectTypeUtils';
export const I18N_SEPARATOR = '.';
export const getLongestValidI18nKey = (base, suffix) => {
  if (!suffix) return base;
  const keys = Array.isArray(suffix) ? suffix : suffix.split(I18N_SEPARATOR);
  while (keys && keys.length > 0) {
    const path = `${base}.${keys.join(I18N_SEPARATOR)}`;
    if (isValidI18nKey(path)) {
      return path;
      // @ts-expect-error No external types because of this https://git.hubteam.com/HubSpot/I18n/blob/8dfc22d4a4b334cccd816ea41ad4d701738287d5/static/js/i18n.js#L369
    } else if (I18n.lookup(path) && isValidI18nKey(`${path}.default`)) {
      return `${path}.default`;
    }
    keys.pop();
  }
  return base;
};
export const getObjectTypeInformation = ({
  objectTypeDefinition
}) => {
  const objectTypeName = getObjectTypeName({
    objectTypeDefinition,
    isPlural: false,
    isCapitalized: false
  });
  const objectTypeNamePlural = getObjectTypeName({
    objectTypeDefinition,
    isPlural: true,
    isCapitalized: false
  });
  const objectTypeNameCapitalized = getObjectTypeName({
    objectTypeDefinition,
    isPlural: false,
    isCapitalized: true
  });
  const objectTypeNamePluralAndCapitalized = getObjectTypeName({
    objectTypeDefinition,
    isPlural: true,
    isCapitalized: true
  });
  return {
    objectTypeName,
    objectTypeNamePlural,
    objectTypeNameCapitalized,
    objectTypeNamePluralAndCapitalized
  };
};

/**
 * This is the companion string version of FormattedMessageWithObjectTypeName.
 * It takes the same props, plus the `objectTypeDefinition` prop which
 * is defined as the "object type definition". This can be
 * grabbed from the redux store.
 */
export const getFormattedMessageWithObjectTypeName = ({
  baseLangKey,
  objectTypeDefinition,
  options
}) => {
  if (!baseLangKey.endsWith('_cob')) {
    devLogger.warn({
      key: 'automation-ui-i18n: getFormattedMessageWithObjectTypeName',
      message: `getFormattedMessageWithObjectTypeName called with invalid baseLangKey not ending in _cob for ${baseLangKey}`
    });
  }
  const {
    objectTypeName,
    objectTypeNamePlural,
    objectTypeNameCapitalized,
    objectTypeNamePluralAndCapitalized
  } = getObjectTypeInformation({
    objectTypeDefinition
  });
  return unescapedText(baseLangKey, Object.assign({
    objectTypeName,
    objectTypeNamePlural,
    objectTypeNameCapitalized,
    objectTypeNamePluralAndCapitalized
  }, options));
};